/* eslint-disable import/no-cycle */
import {cloneDeep} from 'lodash';
import i18n from '../../i18n/i18n';
import WidgetSettingFormField from '../shared/widgets/WidgetSettingFormField';
import {Operation} from '../../models/operation';
import {BaseWidgetConfig} from '../shared/widgets/baseWidgetConfig';
import {Component} from '../../models/component';
import {UnitOfMeasurementType} from '../../models/unitOfMeasurement';
import {Order} from '../../models/order';
import appConfig from '../../utils/appConfig';
import {ValidationRules} from '../../utils/validationRules';

export class OperationWidgetConfig extends BaseWidgetConfig {
  // eslint-disable-next-line class-methods-use-this
  get tabs() {
    return [
      {
        key: 'modalTabs',
        label: i18n.t('activeOperationWidget.settings.modalTabs'),
      },
      {
        key: 'modalTabGeneral',
        label: i18n.t('activeOperationWidget.settings.modalTabGeneral'),
      },
      {
        key: 'modalTabCustom',
        label: i18n.t('activeOperationWidget.settings.modalTabCustom'),
      },
      {
        key: 'modalTabComponents',
        label: i18n.t('activeOperationWidget.settings.modalTabComponents'),
      },
      {
        key: 'modalTabInterruptions',
        label: i18n.t('activeOperationWidget.settings.modalTabInterruptions'),
      },

    ];
  }

  modalTabs = [
    {
      id: 'modalTabs',
      label: i18n.t('activeOperationWidget.settings.tabs.description'),
      type: WidgetSettingFormField.fieldTypes.Properties,
      texts: {
        headerPropertyName: i18n.t('activeOperationWidget.settings.tabs.headerPropertyName'),
        hiddenProperties: i18n.t('activeOperationWidget.settings.tabs.hiddenTabs'),
        visibleProperties: i18n.t('activeOperationWidget.settings.tabs.visibleTabs'),
        itemUnit: i18n.t('activeOperationWidget.settings.tabs.itemUnit'),
        itemsUnit: i18n.t('activeOperationWidget.settings.tabs.itemsUnit'),
        selectAll: i18n.t('activeOperationWidget.settings.tabs.selectAll'),
      },
      properties: [
        {
          key: 'tabGeneral',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.general'),
          enabled: true,
        },
        {
          key: 'tabCustom',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.custom'),
          enabled: true,
        },
        {
          key: 'tabComponents',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.components'),
          enabled: true,
        },
        {
          key: 'tabOrderMaterials',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.orderMaterials'),
          enabled: true,
        },
        {
          key: 'tabYields',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.yields'),
          enabled: appConfig.modules.enableYields,
        },
        {
          key: 'tabDocuments',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.documents'),
          enabled: true,
        },
        {
          key: 'tabMessages',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.messages'),
          enabled: true,
        },
        {
          key: 'tabShiftBook',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.shiftBook'),
          enabled: true,
        },
        {
          key: 'tabTasks',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.tasks'),
          enabled: true,
        },
        {
          key: 'tabInterruptions',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.interruptions'),
          enabled: true,
        },
        {
          key: 'tabEventLog',
          title: i18n.t('activeOperationWidget.settings.modal.tabs.eventLog'),
          enabled: true,
        },
      ].filter((tab) => tab.enabled),
      defaultValue: ['tabGeneral'],
    },
  ];
  modalTabCustom = [
    {
      id: 'modalTabCustom.tabs',
      type: WidgetSettingFormField.fieldTypes.CustomTabEditor,
      defaultValue: [{
        title: i18n.t('activeOperationWidget.settings.modal.custom.defaultTabTitle'),
        icon: 'infoCircle',
        columnCount: 1,
        groups: [{
          title: i18n.t('activeOperationWidget.settings.modal.custom.defaultGroupTitle'),
          showGroupLabel: false,
          columnCount: 1,
          showPropertyLabels: true,
          properties: [],
        }],
      }],
    },
  ];

  modalTabComponents = [
    {
      id: 'modalTabComponents.groupComponents',
      label: i18n.t('activeOperationWidget.settings.modal.components.groupComponents.label'),
      helpText: i18n.t('activeOperationWidget.settings.modal.components.groupComponents.helpText'),
      type: WidgetSettingFormField.fieldTypes.Boolean,
      defaultValue: true,
    },
    {
      id: 'modalTabComponents.properties',
      label: i18n.t('activeOperationWidget.settings.modal.components.tabTitle'),
      type: WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField,
      modelOptions: Component.allDisplayableProperties(this.rootStore),
      defaultValue: [
        'no',
        'info',
        'material.no',
        'material.name',
        'plannedQuantity',
        'actualQuantity',
        'unitOfMeasure',
      ],
    },
  ];

  modalTabGeneral = [
    {
      id: 'modalTabGeneral.unitOfMeasurementTypes',
      label: i18n.t('activeOperationWidget.settings.modal.general.unitOfMeasurementTypes'),
      type: WidgetSettingFormField.fieldTypes.SelectMultiple,
      options: Object.values(UnitOfMeasurementType).map((type) => ({label: type, value: type})),
      defaultValue: [UnitOfMeasurementType.TU, UnitOfMeasurementType.LU],
    },
    {
      id: 'modalTabGeneral.showOrderFirst',
      label: i18n.t('activeOperationWidget.settings.modal.general.showOrderFirst'),
      type: WidgetSettingFormField.fieldTypes.Boolean,
      defaultValue: true,
    },
    {
      id: 'modalTabGeneral.showPhaseMachineHours',
      label: i18n.t('activeOperationWidget.settings.modal.general.showPhaseMachineHours.label'),
      type: WidgetSettingFormField.fieldTypes.Boolean,
      defaultValue: true,
    },
    {
      id: 'modalTabGeneral.operationProperties',
      label: i18n.t('activeOperationWidget.settings.modal.general.operationProperties.label'),
      type: WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField,
      modelOptions: Operation.allDisplayableProperties(this.rootStore),
      defaultValue: [],
    },
    {
      id: 'modalTabGeneral.orderProperties',
      label: i18n.t('activeOperationWidget.settings.modal.general.orderProperties.label'),
      type: WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField,
      modelOptions: Order.allDisplayableProperties(this.rootStore),
      defaultValue: [],
    },
  ];

  modalTabInterruptions = [
    {
      id: 'modalTabInterruption.columns',
      label: i18n.t('activeOperationWidget.settings.modal.interruptions.columns.label'),
      helpText: i18n.t('activeOperationWidget.settings.modal.interruptions.columns.help'),
      type: WidgetSettingFormField.fieldTypes.Number,
      defaultValue: 3,
      validations: [
        ValidationRules.required,
        ValidationRules.integer,
        ValidationRules.greaterThanOrEqualTo(1),
        ValidationRules.lessThanOrEqualTo(6),
      ],
    },
    {
      id: 'modalTabInterruption.sortAttribute',
      label: i18n.t('activeOperationWidget.settings.modal.interruptions.sortAttribute.label'),
      helpText: i18n.t('activeOperationWidget.settings.modal.interruptions.sortAttribute.help'),
      type: WidgetSettingFormField.fieldTypes.Select,
      options: ['time', 'duration'].map((value) => ({
        value,
        label: i18n.t(`activeOperationWidget.settings.modal.interruptions.sortAttribute.options.${value}.label`),
        helpText: i18n.t(`activeOperationWidget.settings.modal.interruptions.sortAttribute.options.${value}.help`),
      })),
      defaultValue: 'time',
      validations: [ValidationRules.required],
    },
    {
      id: 'modalTabInterruption.sortOrder',
      label: i18n.t('activeOperationWidget.settings.modal.interruptions.sortOrder.label'),
      helpText: i18n.t('activeOperationWidget.settings.modal.interruptions.sortOrder.help'),
      type: WidgetSettingFormField.fieldTypes.Select,
      options: ['ascend', 'descend'].map((value) => ({
        value,
        label: i18n.t(`activeOperationWidget.settings.modal.interruptions.sortOrder.options.${value}.label`),
        helpText: i18n.t(`activeOperationWidget.settings.modal.interruptions.sortOrder.options.${value}.help`),
      })),
      defaultValue: 'ascend',
      validations: [ValidationRules.required],
    },
  ];

  getGeneralTabSettings(identifier) {
    return this.getSettingValue('modalTabGeneral', identifier);
  }

  getCustomTabSetting(identifier) {
    return this.getSettingValue('modalTabCustom', identifier);
  }

  getCustomTabs() {
    const tabsConfig = cloneDeep(this.getSettingValue('modalTabCustom', 'modalTabCustom.tabs'));
    const availableProperties = Operation.allDisplayableProperties(this.rootStore);

    tabsConfig.forEach((tabConfig) => {
      tabConfig.columnCount = parseInt(tabConfig.columnCount, 10);
      tabConfig.groups?.forEach((group) => {
        group.columnCount = parseInt(group.columnCount, 10);
        group.properties = group.properties?.map(
          (item) => this.mapSettingPropertyKeyToProperty({
            modelOptions: availableProperties,
            type: WidgetSettingFormField.fieldTypes.PropertiesSelectDisplayField,
          }, item)
        );
      });
    });

    return tabsConfig;
  }

  getInterruptionsTabSetting(identifier) {
    return this.getSettingValue('modalTabInterruptions', identifier);
  }

  getModalTabsSetting(identifier) {
    return this.getSettingValue('modalTabs', identifier);
  }

  getGeneralTabOperationProperties() {
    return this.getSelectedProperties('modalTabGeneral', 'modalTabGeneral.operationProperties');
  }

  getGeneralTabOrderProperties() {
    return this.getSelectedProperties('modalTabGeneral', 'modalTabGeneral.orderProperties');
  }

  getCustomTabProperties() {
    return this.getSelectedProperties('modalTabCustom', 'modalTabCustom.properties');
  }

  getComponentsTableColumns() {
    return this.getSelectedProperties('modalTabComponents', 'modalTabComponents.properties');
  }

  getComponentsTableSettings(identifier) {
    return this.getSettingValue('modalTabComponents', identifier);
  }
}
